import * as React from 'react'
import dynamic from 'next/dynamic'

import {
  FooterThemeInterface,
  SocialIcon,
} from '@thg-commerce/gravity-patterns/Footer/theme'
import { styled, useTheme } from '@thg-commerce/gravity-patterns/theme'
import { mq, spacing, Text } from '@thg-commerce/gravity-theme'

const SocialIconPlaceholder = () => {
  return <div style={{ width: 40, height: 40 }}></div>
}

const CircularFacebook = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/Colour/CircularFacebook'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const CircularInstagram = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/Colour/CircularInstagram'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const CircularLine = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/Colour/CircularLine'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const CircularPinterest = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/Colour/CircularPinterest'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const CircularSnapchat = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/Colour/CircularSnapchat'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const CircularTwitter = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/Colour/CircularTwitter'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const CircularTwentyOneButtons = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/Colour/Circular21Buttons'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const CircularVk = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/Colour/CircularVk'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const CircularWhatsapp = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/Colour/CircularWhatsapp'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const CircularYoutube = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/Colour/CircularYoutube'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const CircularTwitch = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/Colour/CircularTwitch'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const CircularTikTok = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/Colour/CircularTikTok'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const GreyFacebook = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/Grey/GreyFacebook'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const GreyTwitter = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/Grey/GreyTwitter'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const GreyInstagram = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/Grey/GreyInstagram'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const GreyPinterest = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/Grey/GreyPinterest'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const GreyTikTok = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/Grey/GreyTikTok'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const GreyYouTube = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/Grey/GreyYouTube'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const WhiteOpacityFacebook = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/WhiteOpacity/WhiteOpacityFacebook'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const WhiteOpacityTwitter = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/WhiteOpacity/WhiteOpacityTwitter'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const WhiteOpacityInstagram = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/WhiteOpacity/WhiteOpacityInstagram'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const WhiteOpacityYouTube = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/WhiteOpacity/WhiteOpacityYouTube'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const WhiteOpacityPinterest = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/WhiteOpacity/WhiteOpacityPinterest'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const WhiteOpacityTiktok = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/WhiteOpacity/WhiteOpacityTiktok'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const WhiteOutlineFacebook = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/WhiteOutline/WhiteOutlineFacebook'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const WhiteOutlineTwitter = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/WhiteOutline/WhiteOutlineTwitter'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const WhiteOutlineYoutube = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/WhiteOutline/WhiteOutlineYoutube'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const WhiteOutlineInstagram = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/WhiteOutline/WhiteOutlineInstagram'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const WhiteOutlineTikTok = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/WhiteOutline/WhiteOutlineTikTok'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const BlackFacebook = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/Black/BlackFacebook'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const BlackTwitter = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/Black/BlackTwitter'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const BlackInstagram = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/Black/BlackInstagram'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const BlackTikTok = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/Black/BlackTikTok'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const BlackYouTube = dynamic(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/SocialIcons/Black/BlackYouTube'
    ),
  { loading: () => <SocialIconPlaceholder /> },
)
const SvgIcon = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/SvgIcon'),
  { ssr: true, loading: () => <div style={{ width: 24, height: 24 }} /> },
)

const StyledConnectWithUs = styled.div`
  margin-left: ${spacing(0)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin-left: ${spacing(2)};
  }
`

const TagLine = styled.div`
  padding-bottom: ${spacing(2)};
  ${(props) =>
    Text(
      props.theme.patterns.footer.customerEngagement.headerText.entry ||
        'bodyText',
      props.theme.patterns.footer.customerEngagement.headerText.style ||
        'alternate',
    )}
  text-transform: ${(props) =>
    props.theme.patterns.footer.customerEngagement.headerText.transform ||
    'none'};
  text-decoration: ${(props) =>
    props.theme.patterns.footer.customerEngagement.headerText.textDecoration ||
    'none'};
  color: ${(props) =>
    props.theme.patterns.footer.customerEngagement.headerText.textColor};
`

const CircularSocialLinks = styled.a`
  display: inline-flex;
  border: solid
    ${(props) =>
      props.theme.patterns.footer.customerEngagement.socialIconsBorder.display
        ? `${props.theme.patterns.footer.customerEngagement.socialIconsBorder.width} 
           ${props.theme.patterns.footer.customerEngagement.socialIconsBorder.color}`
        : `2px transparent`};
  height: ${(props) => (props.isColorSocialIcon ? '48px' : '44px')};
  padding: ${(props) =>
    props.isColorSocialIcon
      ? spacing(0.25)
      : props.theme.patterns.footer.customerEngagement.socialIconsPadding ||
        '0px'};
  border-radius: 25px;
  align-items: center;

  &:focus-visible {
    outline: none;
    border: 2px solid
      ${(props) =>
        props.theme.patterns.footer.customerEngagement.socialIconsBorder
          .color || props.theme.colors.palette.brand.base};
  }

  &:hover {
    ${(props) =>
      props.theme.patterns.footer.customerEngagement?.socialIconsOutline?.color
        ? `outline: 2px solid ${props.theme.patterns.footer.customerEngagement.socialIconsOutline.color};`
        : `opacity: 0.6`}
  }

  ${(props) =>
    props.theme.patterns.footer.customerEngagement.socialIconType ===
      SocialIcon.grey &&
    `svg {
      circle {
        fill: ${props.theme.patterns.footer.customerEngagement.socialIconsFill.circle};
      }
      path {
        fill: ${props.theme.patterns.footer.customerEngagement.socialIconsFill.path};
      }
    }`}
`

const InlineLi = styled.li`
  padding-right: ${(props) =>
    spacing(
      props.theme.patterns.footer.customerEngagement.socialIconsPadding ? 0 : 1,
    )};
  display: inline;
`

interface ActionProps {
  href: string
  as?: string
  children: React.ReactElement
  [x: string]: any
}

export interface ConnectWithUsProps {
  text: string
  socialAccounts: { url: string; socialNetwork: string }[]
  actionComponent: React.FunctionComponent<ActionProps>
}

const greyIcons = (
  socialIconTheme: FooterThemeInterface['customerEngagement']['socialIcon'],
) => {
  return {
    FACEBOOK: socialIconTheme.facebook.svgPath ? (
      <SvgIcon
        xmlns="http://www.w3.org/2000/svg"
        viewBox={socialIconTheme.viewBox}
        width={socialIconTheme.width}
        height={socialIconTheme.height}
      >
        <path d={socialIconTheme.facebook.svgPath} fillRule="evenodd" />
      </SvgIcon>
    ) : (
      <GreyFacebook />
    ),
    INSTAGRAM: <GreyInstagram />,
    YOUTUBE: <GreyYouTube />,
    TWITTER: <GreyTwitter />,
    PINTEREST: socialIconTheme.pinterest.svgPath ? (
      <SvgIcon
        xmlns="http://www.w3.org/2000/svg"
        viewBox={socialIconTheme.viewBox}
        width={socialIconTheme.width}
        height={socialIconTheme.height}
      >
        <path d={socialIconTheme.pinterest.svgPath} fillRule="nonzero" />
      </SvgIcon>
    ) : (
      <GreyPinterest />
    ),
    TIKTOK: <GreyTikTok />,
    WHATSAPP: socialIconTheme.whatsapp.svgPath ? (
      <SvgIcon
        xmlns="http://www.w3.org/2000/svg"
        width={socialIconTheme.width}
        height={socialIconTheme.height}
      >
        <path d={socialIconTheme.whatsapp.svgPath} fillRule="nonzero" />
      </SvgIcon>
    ) : (
      <GreyFacebook />
    ),
  }
}

const iconTypes: { [key: string]: SocialIcon } = {
  black: SocialIcon.black,
  colour: SocialIcon.color,
  grey: SocialIcon.grey,
  whiteOpacity: SocialIcon.whiteOpacity,
  whiteOutline: SocialIcon.whiteOutline,
}

const whiteOpacityIcon: { [key: string]: React.ReactElement } = {
  FACEBOOK: <WhiteOpacityFacebook />,
  INSTAGRAM: <WhiteOpacityInstagram />,
  YOUTUBE: <WhiteOpacityYouTube />,
  TWITTER: <WhiteOpacityTwitter />,
  PINTEREST: <WhiteOpacityPinterest />,
  TIKTOK: <WhiteOpacityTiktok />,
}

const blackIcons: { [key: string]: React.ReactElement } = {
  FACEBOOK: <BlackFacebook />,
  INSTAGRAM: <BlackInstagram />,
  YOUTUBE: <BlackYouTube />,
  TWITTER: <BlackTwitter />,
  TIKTOK: <BlackTikTok />,
}

const whiteOutlineIcon: { [key: string]: React.ReactElement } = {
  FACEBOOK: <WhiteOutlineFacebook />,
  TWITTER: <WhiteOutlineTwitter />,
  YOUTUBE: <WhiteOutlineYoutube />,
  INSTAGRAM: <WhiteOutlineInstagram />,
  TIKTOK: <WhiteOutlineTikTok />,
}

const socialIcons: { [key: string]: React.ReactElement } = {
  FACEBOOK: <CircularFacebook />,
  INSTAGRAM: <CircularInstagram />,
  LINE: <CircularLine />,
  PINTEREST: <CircularPinterest />,
  SNAPCHAT: <CircularSnapchat />,
  TIKTOK: <CircularTikTok />,
  TWENTYONE_BUTTONS: <CircularTwentyOneButtons />,
  TWITCH: <CircularTwitch />,
  TWITTER: <CircularTwitter />,
  VK: <CircularVk />,
  WHATSAPP: <CircularWhatsapp />,
  YOUTUBE: <CircularYoutube />,
}

export const ConnectWithUs = ({
  actionComponent: PassedActionComponent,
  ...props
}: ConnectWithUsProps) => {
  const theme = useTheme()

  const getSocialNetworkIcon = (socialNetwork: string, iconType: string) => {
    const socialIconTheme = theme.patterns.footer.customerEngagement.socialIcon

    if (iconType === iconTypes.grey) {
      return greyIcons(socialIconTheme)[socialNetwork] || null
    }
    if (iconType === iconTypes.whiteOpacity) {
      return whiteOpacityIcon[socialNetwork] || null
    }
    if (iconType === iconTypes.black) {
      return blackIcons[socialNetwork] || null
    }
    if (iconType === iconTypes.whiteOutline) {
      return whiteOutlineIcon[socialNetwork] || null
    }
    return socialIcons[socialNetwork] || null
  }

  const createSocialAccountLink = (index, socialAccount) => {
    const socialIcon = getSocialNetworkIcon(
      socialAccount.socialNetwork,
      theme.patterns.footer.customerEngagement.socialIconType,
    )

    if (!socialIcon) {
      return null
    }

    return (
      <InlineLi key={`social-account-circle-${index}`}>
        <PassedActionComponent href={socialAccount.url}>
          <CircularSocialLinks
            target="_blank"
            data-testid="social-account-circle"
            aria-label={socialAccount.socialNetwork.toLowerCase()}
            title={socialAccount.socialNetwork.toLowerCase()}
            isColorSocialIcon={
              theme.patterns.footer.customerEngagement.socialIconType ===
              iconTypes.colour
            }
          >
            {socialIcon}
          </CircularSocialLinks>
        </PassedActionComponent>
      </InlineLi>
    )
  }

  const SocialAccountCircles = props.socialAccounts.map((el, index) => {
    return createSocialAccountLink(index, el)
  })

  return props.socialAccounts.length > 0 ? (
    <StyledConnectWithUs>
      <TagLine id={'social-accounts'}>{props.text}</TagLine>
      <ul aria-labelledby={'social-accounts'}>{SocialAccountCircles}</ul>
    </StyledConnectWithUs>
  ) : null
}
